import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `Informes/seguimientoExtraccionesPool`, method: 'POST', body: list, token: token})
}